import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Container, Placeholder, Row, Col, Card,Tab,Nav, Button } from 'react-bootstrap';
import { dynamicUrl } from './Function';
const filterIds = [10, 11, 12, 13, 14, 9, 16,21];
const ConvocationGlimpses = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const { t } = useTranslation();
    const [glimpse, setGlimpse] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => 
    {
        const fetchGlimpses = async () => 
        {
            try 
            {
                const response = await fetch(`${global.config.API_URL}glimpses/all`);
                const result = await response.json();
                if (result.length > 0) 
                {
                    const allResponses = await Promise.all(
                        result.map(async (e) => {
                            const [ups, upsh, uds] = await Promise.all([
                                fetch(`${global.config.API_URL}upload/details/0/${e.sg_id}/sgPhoto`).then(res => res.json()),
                                fetch(`${global.config.API_URL}upload/details/0/${e.sg_id}/sgPhotoHi`).then(res => res.json()),
                                fetch(`${global.config.API_URL}upload/details/0/${e.sg_id}/siteGlimpses`).then(res => res.json())
                            ]);
                            
                            return {
                                ...e,
                                sgPhoto: ups.length ? global.config.uploadPath + ups[0].up_fname + ups[0].up_ext : '',
                                sgPhotoHi: upsh.length ? global.config.uploadPath + upsh[0].up_fname + upsh[0].up_ext : '',
                                siteGlimpses: uds.length
                            };
                        })
                    );
                    // Filter and sort the responses to maintain filterIds sequence
                    const filteredAndSortedResponses = allResponses
                        .filter(rs => filterIds.includes(rs.sg_id))
                        .sort((a, b) => filterIds.indexOf(a.sg_id) - filterIds.indexOf(b.sg_id));

                    setGlimpse(filteredAndSortedResponses);
                    //setGlimpse(allResponses.filter(rs => filterIds.includes(rs.sg_id)));
                } 
                else 
                {
                    setGlimpse([]);
                }
            } 
            catch (error) 
            {
                console.error('GlimpsesAll Error:', error.message);
                setError('Failed to load data.');
            } 
            finally 
            {
                setLoading(false);
            }
        };
        fetchGlimpses();
    }, []);
    const renderImage = (sg) => 
    {
        if (appLanguage === 'hi') 
        {
            return sg.sgPhotoHi || (sg.sg_display_en === "1" && sg.sgPhoto)
                ? <Card.Img src={sg.sgPhotoHi || sg.sgPhoto} className='img-fluid' alt="झलक चित्र" />
                : null;
        } 
        else 
        {
            return sg.sgPhoto 
                ? <Card.Img src={sg.sgPhoto} className='img-fluid' alt="Glimpse Image" />
                : null;
        }
    };
    return (
        <section style={{ backgroundImage: `url(${global.config.uploadPath + '575342214.jpg'})`, backgroundSize: "cover", backgroundRepeat: "no-repeat" }}>
            <Container className="p-5 text-center">
                <Tab.Container defaultActiveKey="first">
                    <Nav variant="tabs" className="justify-content-center">
                        <Nav.Item>
                            <Nav.Link eventKey="first">{appLanguage === 'hi' ? 'सभी दीक्षांत समारोह' : 'ALL CONVOCATIONS'}</Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                            <Nav.Link eventKey="second">{appLanguage === 'hi' ? 'गैलरी अभिलेखागार' : 'GALLERY ARCHIVES'}</Nav.Link>
                        </Nav.Item>                                    
                    </Nav>
                    <Tab.Content>
                        <Tab.Pane eventKey="first">
                            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 justify-content-center">
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">8<sup>th</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>
                                                <DynamicLink spId={374} />                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">7<sup>th</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>
                                                <DynamicLink spId={337} />                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">6<sup>th</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>
                                                <DynamicLink spId={260} />                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">5<sup>th</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>
                                                <DynamicLink spId={303} />                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">4<sup>th</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>
                                                <DynamicLink spId={310} />                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">3<sup>rd</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>                                                
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">2<sup>nd</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>                                               
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>
                                <Col>
                                    <Card className="text-bg-primary border-primary text-center h-100 shadow-sm">
                                        <Card.Body>
                                            <div className='border border-white border-dashed rounded p-3'>
                                                <div className="number-circle mt-1 mb-3">
                                                    <span className="number">1<sup>st</sup></span>
                                                </div>
                                                <Card.Title className='fs-3'>{appLanguage === 'hi' ? 'दीक्षांत समारोह' : 'Convocation'}</Card.Title>                                               
                                            </div>
                                        </Card.Body>                                        
                                    </Card>
                                </Col>                                
                            </Row>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                        {isLoading ? (
                            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 justify-content-center">
                                {[...Array(5)].map((_, index) => (
                                    <Col key={index}>
                                        <Card className='bg-secondary-subtle text-center'>
                                            <Card.Header className='text-center fs-4' data-aos="flip-up" data-aos-duration="1500">
                                                <Placeholder xs={10} />
                                            </Card.Header>
                                            <Card.Body>
                                                <Placeholder xs={12} style={{ height: "150px" }} className="img-fluid rounded border border-3 mb-3" />
                                                <span className='btn btn-info w-50'><Placeholder xs={10} /></span>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        ) : error ? (
                            <div className="text-danger">{error}</div>
                        ) : (
                            <Row className="row-cols-1 row-cols-sm-2 row-cols-md-3 g-3 justify-content-center">
                                {glimpse.map((sg, index) => (
                                    <Col key={index}>
                                        <Card className="rounded-0 border-0 text-center h-100">
                                            {renderImage(sg)}
                                            <NavLink className="stretched-link" to={appLanguage === 'hi' ? `/झलकियाँ/विवरण/${sg.sg_htaccess_hi || sg.sg_htaccess}` : `/glimpses/details/${sg.sg_htaccess}`} target='_blank' rel="noopener noreferrer">
                                                <span className="visually-hidden">{t('ViewAll')}</span>
                                            </NavLink>
                                        </Card>
                                    </Col>
                                ))}
                            </Row>
                        )}
                        </Tab.Pane>
                    </Tab.Content>
                </Tab.Container>               
            </Container>
        </section>
    );
};
export default ConvocationGlimpses;

const DynamicLink = ({spId}) => 
{
    const { t } = useTranslation();
    const[isLoading, setLoading] = useState(true);
    const[Links,setLinks]=useState([]);
    useEffect(()=>
    {
        const getDynamicLink = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"menu/MenuById/"+spId);
                const result = await response.json();
                setLinks(result);
                setLoading(false);
                if( global.config.IsPrint === true ) { console.info('DynamicLink : Result',result); }
            
            } catch (error) 
            {
                console.error('DynamicLink : Error', error.message);
            }
        };
        getDynamicLink();    
    },[spId])
    return (
        <React.Fragment>
            {isLoading ? (
                <Button variant='info' className='w-50'><Placeholder xs={12} className="rounded" /></Button>
            ) : (
            <React.Fragment>
            {Links.map((sp,index)=>(
                <NavLink className="btn btn-info" to={dynamicUrl(sp)} key={index}>
                    {t('ReadMore')}
                </NavLink>
            ))}
            </React.Fragment>
            )}
        </React.Fragment>
    );
}